import { render, staticRenderFns } from "./Construction.vue?vue&type=template&id=70ac275a&scoped=true&"
import script from "./Construction.vue?vue&type=script&lang=js&"
export * from "./Construction.vue?vue&type=script&lang=js&"
import style0 from "./Construction.vue?vue&type=style&index=0&id=70ac275a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac275a",
  null
  
)

export default component.exports